export default __webpack_public_path__ + "static/media/hapi.cb49b068.svg";